import { APP_VECTOR_STORE_MODE } from "../../../../../services/api/constants";
import { TStore } from "../../../../../services/api/instances/vectorStoreApi/types";
import styles from "./styles.module.css";

interface Props {
  title: string;
  storeType: TStore;
  className?: string;
}

export const DatabaseTitleBlock = ({ title, storeType, className }: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>{title}</div>
      {APP_VECTOR_STORE_MODE === "both" && (
        <div className={styles["store-type-badge"]}>{storeType}</div>
      )}
    </div>
  );
};
